<template>
    <div id="footer">
        <v-footer app fixed class="app-footer">
            <template v-if="userName">
                <span class="footer-item">
                    <v-icon size="12" class="footer-icon">mdi-account-circle-outline</v-icon>
                    {{ $t('header.loginas') }}: <strong>{{ userName }}</strong>
                </span>
                <span class="footer-sep">·</span>
                <span class="footer-item">
                    <v-icon size="12" class="footer-icon">mdi-clock-outline</v-icon>
                    {{ $t('header.lastlogin') }}: {{ lastAccess }}
                </span>
                <v-spacer></v-spacer>
            </template>
            <v-spacer v-else></v-spacer>
            <span class="footer-copy">
                &copy; <a :href="website" class="footer-link">{{ companyName }}</a> {{ copyYear }}. {{ $t('footer.allrightreserved') }}
            </span>
        </v-footer>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data () {
        return {
            companyName: 'Transact2 Sdn. Bhd.',
            copyYear: moment().format('YYYY'),
            website: 'https://www.transact2.com',
            userName: this.$store.getters.userName,
            lastAccess: moment(this.$store.getters.lastAccess).format("ll h:mm:ss A")
        }
    }
}
</script>

<style scoped>
.app-footer {
    background: #ffffff !important;
    border-top: 1px solid #E8EDF5 !important;
    padding: 0 20px !important;
    height: 32px !important;
    min-height: 32px !important;
    font-size: 0.75rem !important;
    color: #64748B !important;
    letter-spacing: normal !important;
}
.footer-item {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    color: #64748B;
    font-size: 0.75rem;
}
.footer-icon {
    color: #94A3B8 !important;
}
.footer-sep {
    color: #CBD5E1;
    margin: 0 6px;
}
.footer-copy {
    font-size: 0.75rem;
    color: #94A3B8;
}
.footer-link {
    color: #4F6BFF;
    text-decoration: none;
}
.footer-link:hover {
    text-decoration: underline;
}
</style>